export enum BundleType {
  LESSON = 'lesson',
  QUIZ = 'quiz',
  MODULE = 'module',
  COURSE = 'course',
  CLASS = 'class',
  WEBINAR = 'webinar',
  POLL_QUIZ = 'poll',
  ASSIGNMENT = 'assignment',
  LIBRARY = 'library',
  IMAGE = 'image',
  VIDEO = 'video',
  USER = 'user',
  CARD = 'card',
  SETTINGS = 'settings',
  SLIDE_SCORM = 'slide_scorm_package',
  LEARNING_PATH = 'learning_path',
  CHAT_CHANNEL = 'channel',
  FILE = 'file',
  PAGE = 'page',
  EVENT = 'event',
  FLIPCARD = 'flipcard',
  BADGE = 'badge',
  CHALLENGE = 'challenge',
  IN_PERSON = 'in_person',
  CONTENT_GROUP = 'content_group',
  INSTA_LEARN = 'instalearn',
  AUDIO = 'audio',
  INSTA_LEARN_TOPIC = 'instalearn_topic'
}
